document.addEventListener('click', (e) => {
    if (!e.target.closest('.cat-filter')) return

    const catFilter = e.target.closest('.cat-filter')
    const filterValue = catFilter.dataset.value
    const isSubFilter = catFilter.classList.contains('cat-filter-sub')
    const childrenId = catFilter.dataset.childrenId // set on parent pills that have children
    const parentId = catFilter.dataset.parentId // set on sub-pills

    const postListing = catFilter.closest('.pc-post-listing')
    if (!postListing) return

    const postContainer = postListing.querySelector('.post-listing')
    const loadMoreBtn = postListing.querySelector('.load-more')
    const loadMoreBtnText = loadMoreBtn?.querySelector('.load-more-text') || null
    const filterContainer = postListing.querySelector('[data-filter-post-type]')
    const postType = filterContainer?.dataset.filterPostType || 'post'
    const filterTaxonomy = filterContainer?.dataset.filterTaxonomy || ''
    const categoryIds = filterContainer?.dataset.categoryIds || loadMoreBtn?.dataset.categoryIds || ''
    const orderby = filterContainer?.dataset.orderby || loadMoreBtn?.dataset.orderby || ''
    const order = filterContainer?.dataset.order || loadMoreBtn?.dataset.order || ''

    // --- Sub-filter group visibility ---
    const allSubGroups = postListing.querySelectorAll('.sub-filter-group')
    const allParents = postListing.querySelectorAll('.cat-filter[data-children-id]')

    const collapseAll = () => {
        allSubGroups.forEach((g) => g.classList.add('hidden'))
        allParents.forEach((btn) => btn.setAttribute('aria-expanded', 'false'))
    }

    const expandGroup = (parentBtn, subGroup) => {
        collapseAll()
        subGroup?.classList.remove('hidden')
        parentBtn?.setAttribute('aria-expanded', 'true')
    }

    if (!filterValue) {
        collapseAll()
    } else if (childrenId) {
        expandGroup(catFilter, postListing.querySelector(`.sub-filter-group[data-parent-id="${catFilter.dataset.value}"]`))
    } else if (isSubFilter && parentId) {
        const parentBtn = postListing.querySelector(`.cat-filter[data-children-id="sub-${parentId}"]`)
        expandGroup(parentBtn, postListing.querySelector(`.sub-filter-group[data-parent-id="${parentId}"]`))
    } else {
        collapseAll()
    }

    // Deactivate all pills before the fetch (active state is set after a successful response)
    postListing.querySelectorAll('.cat-filter').forEach((btn) => btn.classList.remove('active'))

    // Update load-more button state
    if (loadMoreBtn) {
        loadMoreBtn.dataset.catId = filterValue
        if (filterTaxonomy) {
            loadMoreBtn.dataset.categoryTaxonomy = filterTaxonomy
        }
    }

    const data = new FormData()
    data.append('action', 'load_more')
    data.append('security', liGlobal.loadMore)
    data.append('cat_id', filterValue)
    data.append('post_type', postType)
    if (filterTaxonomy) {
        data.append('category_taxonomy', filterTaxonomy)
    }
    if (categoryIds) {
        data.append('category_ids', categoryIds)
    }
    if (loadMoreBtn?.dataset.postsPerPage) {
        data.append('posts_per_page', loadMoreBtn.dataset.postsPerPage)
    }
    if (orderby) {
        data.append('orderby', orderby)
    }
    if (order) {
        data.append('order', order)
    }

    fetch(liGlobal.ajaxUrl, {
        method: 'POST',
        body: data,
    })
        .then((response) => response.json())
        .then((response) => {
            if (!response.success) return

            catFilter.classList.add('active')

            const posts = response.data.posts || []
            const maxNumPages = parseInt(response.data.max_num_pages || '0', 10)
            const hasMorePages = maxNumPages > 1

            if (!postContainer) return

            postContainer.innerHTML = ''
            posts.forEach((post) => {
                postContainer.insertAdjacentHTML('beforeend', post)
            })

            if (!loadMoreBtn) return

            loadMoreBtn.classList.remove('loading')
            loadMoreBtn.dataset.paged = '1'
            loadMoreBtn.dataset.maxPages = maxNumPages.toString()

            if (hasMorePages) {
                loadMoreBtn.removeAttribute('disabled')
                loadMoreBtn.style.display = ''
                if (loadMoreBtnText) {
                    loadMoreBtnText.textContent = 'Ladda fler'
                }
            } else {
                loadMoreBtn.setAttribute('disabled', 'disabled')
                loadMoreBtn.style.display = 'none'
            }
        })
})
